<div class="dialog-header">
  <mat-icon class="header-icon">feedback</mat-icon>
  <h1 mat-dialog-title>Report a Problem or Concern</h1>
</div>

<div mat-dialog-content class="dialog-content">
  @if (data.type || data.description) {
    <div class="info-section">
      @if (data.type) {
        <div class="info-item">
          <span class="label">Type:</span>
          <span class="type">{{ data.type }}</span>
        </div>
      }
      @if (data.description) {
        <div class="info-item">
          <span class="label">Description:</span>
          <span class="description">{{ data.description }}</span>
        </div>
      }
    </div>
  }

  <mat-form-field class="comments" appearance="outline">
    <mat-label>Please describe the issue or provide feedback</mat-label>
    <textarea
      giq-auto-resize
      [formControl]="comments"
      [giqColorValidation]="comments"
      matInput
      rows="4"
      placeholder="Describe the problem or share your feedback..."
    ></textarea>
    <mat-hint>Your feedback helps us improve the application</mat-hint>
  </mat-form-field>
</div>

<div mat-dialog-actions class="dialog-actions" [align]="saving ? 'center' : 'end'">
  @if (!saving) {
    <button mat-stroked-button cdkFocusInitial (click)="cancel()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="save()">
      <mat-icon>send</mat-icon>
      Send Report
    </button>
  }
  @if (saving) {
    <div class="saving-indicator">
      <giq-small-load></giq-small-load>
      <span>Saving your report...</span>
    </div>
  }
</div>
